import React, { useState, useEffect } from 'react';
import { FileText, Code, Eye, Globe, Palette, BarChart3, GitBranch } from 'lucide-react';

const ArtifactCard = ({ artifact, onClick }) => {
  const [dots, setDots] = useState('');

  // Animate dots for streaming artifacts
  useEffect(() => {
    if (artifact.isStreaming) {
      const interval = setInterval(() => {
        setDots(prev => {
          if (prev === '...') return '';
          return prev + '.';
        });
      }, 500);
      return () => clearInterval(interval);
    }
  }, [artifact.isStreaming]);

  const getIcon = () => {
    switch (artifact.type) {
      case 'markdown':
        return <FileText size={16} className="theme-info" />;
      case 'code':
        return <Code size={16} className="theme-success" />;
      case 'html':
        return <Globe size={16} className="theme-warning" />;
      case 'react':
        return <Code size={16} className="theme-info" />;
      case 'svg':
        return <Palette size={16} className="theme-success" />;
      case 'css':
        return <Palette size={16} className="theme-info" />;
      case 'chart':
        return <BarChart3 size={16} className="theme-warning" />;
      case 'mermaid':
        return <GitBranch size={16} className="theme-info" />;
      case 'text':
      default:
        return <FileText size={16} className="theme-text-muted" />;
    }
  };

  const getPreview = () => {
    if (artifact.isStreaming) {
      return `Working${dots}`;
    }
    const lines = artifact.content.split('\n');
    const preview = lines.slice(0, 3).join('\n');
    return preview.length > 100 ? preview.substring(0, 100) + '...' : preview;
  };

  return (
    <div 
      onClick={onClick}
      className="inline-flex flex-col max-w-md p-3 mt-2 mb-2 rounded-lg theme-border border
                 theme-card-bg hover:theme-panel-bg 
                 cursor-pointer transition-all duration-200 hover:shadow-md"
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2 min-w-0">
          {getIcon()}
          <span className="font-medium theme-text-primary truncate text-sm">
            {artifact.title}
          </span>
          {/* {artifact.language && (
            <span className="text-xs bg-gray-100 dark:bg-gray-700 px-1.5 py-0.5 rounded text-gray-600 dark:text-gray-400">
              {artifact.language}
            </span>
          )} */}
        </div>
        <Eye size={14} className="theme-text-muted flex-shrink-0" />
      </div>

      {/* Preview */}
      <div className="text-xs theme-text-secondary font-mono theme-code
                      p-2 rounded theme-border border whitespace-pre-wrap overflow-hidden">
        {getPreview()}
      </div>

      {/* Footer */}
      <div className="flex items-center justify-between mt-2 text-xs theme-text-muted">
        <span>{artifact.type}</span>
        <span>{artifact.isStreaming ? 'Click to watch live' : 'Click to view'}</span>
      </div>
    </div>
  );
};

export default ArtifactCard;